import Header from './components/Header';
import ScrollAnimation from './components/ScrollAnimation';
import ToTopButton from './components/ToTopButton';
import Slider from './components/Slider';
import * as helpers from './helpers';

require('../../scss/style.scss');


// a wrapper to avoid '$' conflict
jQuery(document).ready(($) => {

	const app = {
		init: () => {
			const $nodes = $('[data-js-component]');

			$nodes.each(function() {
				let node = $(this),
					componentName = node.data('js-component'),
					options = node.data('options');

	            if(options) {
	            	options = helpers.toObject(options);
				} 

				if (app.hasOwnProperty(componentName)) {
					app[componentName](node, options);
				}
			});			
		},

		Header: () => {
			const Component = new Header();
		},

		ScrollAnimation: ($element, options) => {
			const Component = new ScrollAnimation($element, options);
		},

		ToTopButton: ($element, options) => {
			const Component = new ToTopButton($element, options);
		},

		Slider: (element, options) => {
			const Component = new Slider(element, options);
		},

		wrapIframes: () => {
			$(document).ready(() => {
				const $iframes = $('iframe');

				if ($iframes.length) {
					$iframes.each(function() {
						$(this).wrap('<div class="iframebox"></div>');
					});
				}
			});
		}
	}

	app.init();
	app.wrapIframes();

});


// WEBPACK FOOTER //
// ./assets/js/src/index.js